import {
	CurrencyType,
	DiscountRoomConditionType,
	DiscountType,
	SaleTypeForPlan,
	SaleTypeForTerm,
} from "@/lib/gql/__generated__/graphql";

import type { DiscountLongTermInputZodSchemaType as InputModel } from "../validation-schema";

/**
 * InputModel の初期値を生成
 * @param hotelID
 * @returns {InputModel}
 */
export const discountLongTermInputModelFactory = (hotelID: string): InputModel => {
	return {
		hotelID,
		discountID: "",
		// 基本設定
		// 公開・非公開
		inSale: false,
		// ディスカウントの名前
		name: "",
		// ディスカウントの説明
		description: "",
		// ディスカウントのコード
		discountCode: "",
		// 最低提供価格
		resourceLowestPrice: {
			amount: 1000,
			currencyType: CurrencyType.Jpy,
		},
		longTermStayDiscountObject: [
			{
				includeSmallestNights: 1,
				discountType: DiscountType.Ratio,
				ratio: 5,
			},
		],

		// 追加設定
		// キャンセル不可にするか
		isUncancelable: false,
		// 販売タイプ
		saleTypeForPlan: SaleTypeForPlan.Limited,
		// 利用可能期間
		saleTypeForTerm: SaleTypeForTerm.Always,
		// 同じ部屋のみ連泊ディスカウントを適用する
		roomConditionType: DiscountRoomConditionType.AnyRoom,

	} satisfies InputModel;
};
